import React from 'react';

export default function Page() {
  return (
    <div>
      <h1>Teste Página de Checkout Produtos</h1>
    </div>
  );
}
